export default {
  agendas: [],
  agenda: {},
  items_agenda: [],
  item_agenda: {},
  pagination: {},
};
